import type {Household} from "../types";

type HouseholdCanDeleteSource = Pick<Household, "can_delete"> & {
  canDelete?: boolean | number | null;
};

/** List/show APIs may send boolean `true` or integer `1`. */
export function isHouseholdCanDelete(household: HouseholdCanDeleteSource): boolean {
  const raw = household.can_delete ?? household.canDelete;
  return raw === true || raw === 1;
}

export function withHouseholdCanDelete<T extends Household>(household: T): T {
  return {
    ...household,
    can_delete: isHouseholdCanDelete(household),
  };
}
